<template>
  <div>
    <div class="coupon-item-price-desc">
      <div
        v-for="(price, priceIdx) in subsidy.availableData.priceList"
        :key="`coupon-item-price-expire-${priceIdx}`"
        class="coupon-item-price-desc-row"
      >
        <span class="price-label">
          {{ price.priceType }} {{ price.ageType }} {{price.price | formatCurrency}}
        </span>
        <span class="ml-4">
          利用期限 {{ price.limApplicableDateFrom | formatDate }}
          ～ {{ price.limApplicableDateTo | formatDate }}
        </span>
      </div>
      <p
        v-show="
          get(subsidy, 'availableData.receptionDateFrom') ||
          get(subsidy, 'availableData.receptionDateTo')
        "
      >
        申込期限 {{ get(subsidy, 'availableData.receptionDateFrom') | formatDate }}
        ～{{ get(subsidy, 'availableData.receptionDateTo') | formatDate }}
      </p>

      <!-- 企業補助金: 保有枚数 -->
      <div v-if="
        isCorporate(subsidy.availableData) &&
        (
          (subsidy.availableData.parsonalUsedMaxCnt && subsidy.availableRemainingCount) ||
          (subsidy.availableRemainingCount === 0 && subsidy.availableData.parsonalUsedMaxCnt)
        )
      ">
        <span>保有枚数&nbsp;</span>
        <span>
          {{ subsidy.availableRemainingCount | formatInteger }}/{{subsidy.availableData.parsonalUsedMaxCnt | formatInteger }}枚
        </span>
      </div>

      <!-- 企業補助金: 利用可能残金 -->
      <div v-if="
        isCorporate(subsidy.availableData) &&
        (
          (subsidy.availableRemainingAmount && subsidy.availableData.parsonalUsedMaxTotalAmt ) ||
          (subsidy.availableRemainingAmount === 0 && subsidy.availableData.parsonalUsedMaxTotalAmt )
        )
      ">
        <span>利用可能残金額&nbsp;</span>
        <span>
          {{ subsidy.availableRemainingAmount | formatInteger }}/{{ subsidy.availableData.parsonalUsedMaxTotalAmt | formatInteger }}円
        </span>
      </div>

      <!-- 健保補助金: 保有枚数 -->
      <div v-if="
        !isCorporate(subsidy.availableData) &&
        remainingCountLabel(subsidy) && 
        remainingCountLabel(subsidy).length > 0
      ">
        <span>保有枚数&nbsp;</span>
        <span
          style="margin-right: 15px"
          v-for="(value, idx) in remainingCountLabel(subsidy)"
          :key="idx"
        >
          {{ value }}枚
        </span>
      </div>
      
      <!-- 健保補助金:保有金額 -->
      <div v-if="
        !isCorporate(subsidy.availableData) && 
        remainingAmountLabel(subsidy) && 
        remainingAmountLabel(subsidy).length > 0
      ">
        <span>保有金額&nbsp;</span>
        <span
          style="margin-right: 15px"
          v-for="(value, idx) in remainingAmountLabel(subsidy)"
          :key="idx"
        >
          {{ value }}円
        </span>
      </div>

      <div class="coupon-collapse-item-desc1">
        <p
          template
          class="planDetail"
          v-for="(desc, index) in descrition"
          v-html="desc"
          :key="index"
        />
      </div>
      <div>
        {{ subsidy.availableData.dispNoteComment }}
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'SubsidyDetail',
  props: {
    subsidy: {
      type: Object,
      default: () => {}
    },
    descrition: {
      type: String,
      default: "",
    }
  },
  methods: {
    get,
    /**
    * 企業補助金か判定する
    */
    isCorporate(availableData) {
      if ( availableData.requestType == this.CONST_DATA.SUBSIDY_REQUEST_TYPE.CORPORATE) {
        return true
      }
      return false
    },
    /**
    * 画面表示用：上限枚数を取得
    * @arg     object[subsidyList]
    * @return: array
    */
    remainingCountLabel(subsidy) {
      let countLabelArr = subsidy?.scrennDisplayItemList?.remainingCountLabel?.value?.split(',') || []
      let countLabel = []
      countLabelArr.forEach((val) => {
        if (!val.includes('上限回数') && !val.includes('|null')) {
          countLabel.push(val.replace('|', '：'))
        }
      })
      return countLabel
    },
    /**
    * 画面表示用：上限金額を取得
    * @arg     object[subsidyList]
    * @return  array
    */
    remainingAmountLabel(subsidy) {
      let amountLabelArr = subsidy.scrennDisplayItemList?.remainingAmountLabel?.value?.split(',') || []
      let amountLabel = []
      amountLabelArr.forEach((val) => {
        if (!val.includes('上限金額') && !val.includes('|null')) {
          amountLabel.push(val.replace('|', '：'))
        }
      })
      return amountLabel
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../ApplyCoupon/style.scss';
</style>